import React from 'react'
import { Field, Input, Control, Icon } from 'Components/common/bulma'
import { Trans } from '@lingui/macro'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons'
import { useMount } from 'ahooks'

import tagsInput from 'bulma-tagsinput'


const TagsInputWithErrorComponent = ({
  label,
  onChange,
  disabled = false,
  error,
  showErrors,
  className,
  tooltip,
  input = {},
}) => {
  let inputRef;

  useMount(() => {

    inputRef = new tagsInput('[type="tags"]', { delimiter: ';', duplicates: false })
    inputRef.reset();
    inputRef.element.addEventListener('change', e => {
      console.log(e)
      onChange(e)
    })
  })

  return (
    <Field>
      <label className="label"><Trans id={label}></Trans>
        {tooltip && <Icon className="tooltip is-tooltip-multiline is-tooltip-info has-text-danger" data-tooltip={tooltip} >
          <FontAwesomeIcon icon={faInfoCircle} />
        </Icon>}
      </label>
      <Control>
        <Input
          type="tags"
          className={className}
          onChange={onChange}
          disabled={disabled}
          {...input}
          placeholder={input.placeholder || label}
          />
      </Control>
      {(error && showErrors) && <p className="has-text-danger help">{error}</p>}
    </Field>
  )
}

export default React.memo(TagsInputWithErrorComponent);
